/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
/* eslint-disable no-param-reassign */
import Fetch, { V1, serializeQueryString } from 'Util/fetcher';

import { ON_PRICE_SOCKET_CHANGE } from './tradeSocket';
import {
  ON_ADD_WATCHLIST_SUCCESS,
  ON_REMOVE_WATCHLIST_SUCCESS,
} from './watchlist';

const ON_REQUEST_STOCK_DISCOVERY = 'ON_REQUEST_STOCK_DISCOVERY';
const ON_REQUEST_STOCK_DISCOVERY_FAILURE = 'ON_REQUEST_STOCK_DISCOVERY_FAILURE';
const ON_REQUEST_STOCK_DISCOVERY_SUCCESS = 'ON_REQUEST_STOCK_DISCOVERY_SUCCESS';

function onRequestStockDiscovery(groupCode) {
  return {
    type: ON_REQUEST_STOCK_DISCOVERY,
    meta: { groupCode },
  };
}

function onRequestStockDiscoverySuccess(payload, groupCode, resetState) {
  return {
    type: ON_REQUEST_STOCK_DISCOVERY_SUCCESS,
    payload,
    meta: { groupCode, resetState },
  };
}

function onRequestStockDiscoveryFailure(payload, groupCode) {
  return {
    type: ON_REQUEST_STOCK_DISCOVERY_FAILURE,
    payload,
    meta: { groupCode },
  };
}

export const onDoRequestStockDiscovery = (payload, groupCode, resetState = false, isDayTrading = false) =>
  (dispatch) => {
    dispatch(onRequestStockDiscovery(groupCode));
    const qs = serializeQueryString(payload);
    const resourceUrl = isDayTrading 
    ? `${V1}stock/odt/stock-tradable/discovery/${qs}`
    : `${V1}stock/discovery/group/member/${qs}`
    Fetch.get(resourceUrl)
      .then((resp) => {
        if (resp.ok) {
          dispatch(
            onRequestStockDiscoverySuccess(resp.json, groupCode, resetState)
          );
        } else {
          dispatch(onRequestStockDiscoveryFailure(resp.json, groupCode));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockDiscoveryFailure(error.message, groupCode));
      });
  };

const ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY = 'ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY';
const ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_FAILURE = 'ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_FAILURE';
const ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_SUCCESS = 'ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_SUCCESS';

function onRequestStockGraphDiscovery(rangeCode, vendorCode) {
  return {
    type: ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY,
    meta: { rangeCode, vendorCode },
  };
}

function onRequestStockGraphDiscoverySuccess(payload, rangeCode, vendorCode) {
  return {
    type: ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_SUCCESS,
    payload,
    meta: { rangeCode, vendorCode },
  };
}

function onRequestStockGraphDiscoveryFailure(payload, rangeCode, vendorCode) {
  return {
    type: ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_FAILURE,
    payload,
    meta: { rangeCode, vendorCode },
  };
}

export const onDoRequestStockGraphDiscovery = (rangeCode, vendorCode = 'COMPOSITE') =>
  (dispatch) => {
    dispatch(onRequestStockGraphDiscovery(rangeCode, vendorCode));
    const payload = {
      code: vendorCode,
      range: rangeCode,
    };
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/pricegraph/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(
            onRequestStockGraphDiscoverySuccess(
              resp.json,
              rangeCode,
              vendorCode
            )
          );
        } else {
          dispatch(
            onRequestStockGraphDiscoveryFailure(
              resp.json,
              rangeCode,
              vendorCode
            )
          );
        }
      })
      .catch((error) => {
        dispatch(
          onRequestStockGraphDiscoveryFailure(
            error.message,
            rangeCode,
            vendorCode
          )
        );
      });
  };

// CANDLE STICK
const ON_REQUEST_CANDLESTICK_GRAPH = 'ON_REQUEST_CANDLESTICK_GRAPH';
const ON_REQUEST_CANDLESTICK_GRAPH_FAILURE = 'ON_REQUEST_CANDLESTICK_GRAPH_FAILURE';
const ON_REQUEST_CANDLESTICK_GRAPH_SUCCESS = 'ON_REQUEST_CANDLESTICK_GRAPH_SUCCESS';

function onRequestCandleStickGraph(rangeCode, vendorCode) {
  return {
    type: ON_REQUEST_CANDLESTICK_GRAPH,
    meta: { rangeCode, vendorCode },
  };
}

function onRequestCandleStickGraphSuccess(payload) {
  return {
    type: ON_REQUEST_CANDLESTICK_GRAPH_SUCCESS,
    payload,
  };
}

function onRequestCandleStickGraphFailure(payload) {
  return {
    type: ON_REQUEST_CANDLESTICK_GRAPH_FAILURE,
    payload,
  };
}

export const onDoRequestCandleStickGraph = (rangeCode, vendorCode = 'COMPOSITE') =>
  (dispatch) => {
    dispatch(onRequestCandleStickGraph(rangeCode, vendorCode));
    const payload = {
      code: vendorCode,
      range: rangeCode,
    };
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/data/pricegraph/candlestick/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestCandleStickGraphSuccess(resp.json));
        } else {
          dispatch(onRequestCandleStickGraphFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestCandleStickGraphFailure(error.message));
      });
  };

// ---//

const ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY = 'ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY';
const ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_FAILURE = 'ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_FAILURE';
const ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_SUCCESS = 'ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_SUCCESS';

function onRequestMarketIndexListDiscovery(resetData) {
  return {
    type: ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY,
    meta: { resetData },
  };
}

function onRequestMarketIndexListDiscoverySuccess(payload) {
  return {
    type: ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_SUCCESS,
    payload,
  };
}

function onRequestMarketIndexListDiscoveryFailure(payload) {
  return {
    type: ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_FAILURE,
    payload,
  };
}

export const onDoRequestMarketIndexListDiscovery = (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestMarketIndexListDiscovery(resetData));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/market_index/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestMarketIndexListDiscoverySuccess(resp.json));
        } else {
          dispatch(onRequestMarketIndexListDiscoveryFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestMarketIndexListDiscoveryFailure(error.message));
      });
  };

const ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE = 'ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE';
const ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_FAILURE = 'ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_FAILURE';
const ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_SUCCESS = 'ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_SUCCESS';

function onRequestStockDiscoveryGroupType(type, resetState) {
  return {
    type: ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE,
    meta: { type, resetState },
  };
}

function onRequestStockDiscoveryGroupTypeSuccess(payload, type) {
  return {
    type: ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_SUCCESS,
    payload,
    meta: { type },
  };
}

function onRequestStockDiscoveryGroupTypeFailure(payload, type) {
  return {
    type: ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_FAILURE,
    payload,
    meta: { type },
  };
}

export const onDoRequestStockDiscoveryGroupType = (payload, type, resetState = false) =>
  (dispatch) => {
    dispatch(onRequestStockDiscoveryGroupType(type, resetState));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/discovery/group/type/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestStockDiscoveryGroupTypeSuccess(resp.json, type));
        } else {
          dispatch(onRequestStockDiscoveryGroupTypeFailure(resp.json, type));
        }
      })
      .catch((error) => {
        dispatch(onRequestStockDiscoveryGroupTypeFailure(error.message, type));
      });
  };

const ON_DO_SET_FILTER = 'ON_DO_SET_FILTER';

export function onDoSetFilter(payload) {
  return {
    type: ON_DO_SET_FILTER,
    payload,
  };
}

// etf
const ON_REQUEST_ETF_LIST = 'ON_REQUEST_ETF_LIST';
const ON_REQUEST_ETF_LIST_FAILURE = 'ON_REQUEST_ETF_LIST_FAILURE';
const ON_REQUEST_ETF_LIST_SUCCESS = 'ON_REQUEST_ETF_LIST_SUCCESS';

function onRequestETFList(resetData) {
  return {
    type: ON_REQUEST_ETF_LIST,
    meta: { resetData },
  };
}

function onRequestETFListSuccess(payload) {
  return {
    type: ON_REQUEST_ETF_LIST_SUCCESS,
    payload,
  };
}

function onRequestETFListFailure(payload) {
  return {
    type: ON_REQUEST_ETF_LIST_FAILURE,
    payload,
  };
}

export const onDoRequestETFList = (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestETFList(resetData));
    Fetch.get(`${V1}stock/data/etf/${payload}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestETFListSuccess(resp.json));
        } else {
          dispatch(onRequestETFListFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestETFListFailure(error.message));
      });
  };

// commodity
const ON_REQUEST_COMMODITY_LIST = 'ON_REQUEST_COMMODITY_LIST';
const ON_REQUEST_COMMODITY_LIST_FAILURE = 'ON_REQUEST_COMMODITY_LIST_FAILURE';
const ON_REQUEST_COMMODITY_LIST_SUCCESS = 'ON_REQUEST_COMMODITY_LIST_SUCCESS';

function onRequestCommodityList(resetData) {
  return {
    type: ON_REQUEST_COMMODITY_LIST,
    meta: { resetData },
  };
}

function onRequestCommodityListSuccess(payload) {
  return {
    type: ON_REQUEST_COMMODITY_LIST_SUCCESS,
    payload,
  };
}

function onRequestCommodityListFailure(payload) {
  return {
    type: ON_REQUEST_COMMODITY_LIST_FAILURE,
    payload,
  };
}

export const onDoRequestCommodityList = (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestCommodityList(resetData));
    Fetch.get(`${V1}stock/data/commodity/${payload}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestCommodityListSuccess(resp.json));
        } else {
          dispatch(onRequestCommodityListFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestCommodityListFailure(error.message));
      });
  };

// currency
const ON_REQUEST_CURRENCY_LIST = 'ON_REQUEST_CURRENCY_LIST';
const ON_REQUEST_CURRENCY_LIST_FAILURE = 'ON_REQUEST_CURRENCY_LIST_FAILURE';
const ON_REQUEST_CURRENCY_LIST_SUCCESS = 'ON_REQUEST_CURRENCY_LIST_SUCCESS';

function onRequestCurrencyList(resetData) {
  return {
    type: ON_REQUEST_CURRENCY_LIST,
    meta: { resetData },
  };
}

function onRequestCurrencyListSuccess(payload) {
  return {
    type: ON_REQUEST_CURRENCY_LIST_SUCCESS,
    payload,
  };
}

function onRequestCurrencyListFailure(payload) {
  return {
    type: ON_REQUEST_CURRENCY_LIST_FAILURE,
    payload,
  };
}

export const onDoRequestCurrencyList = (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestCurrencyList(resetData));
    Fetch.get(`${V1}stock/data/currency/${payload}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestCurrencyListSuccess(resp.json));
        } else {
          dispatch(onRequestCurrencyListFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestCurrencyListFailure(error.message));
      });
  };

const INITIAL_STATE = {
  stockDiscoveryLoading: null,
  stockDiscoveryData: null,
  stockDiscoveryError: null,

  stockGraphDiscoveryLoading: {},
  stockGraphDiscoveryData: {},
  stockGraphDiscoveryError: {},

  candleStickLoading: {},
  candleStickData: {},
  candleStickError: {},

  marketIndexListLoading: false,
  marketIndexListData: null,
  marketIndexListError: null,

  stockDiscoveryTypeLoading: {},
  stockDiscoveryTypeData: {},
  stockDiscoveryTypeError: {},

  selectedFilter: null,

  etfListLoading: null,
  etfListData: null,
  etfListError: null,

  commodityListLoading: null,
  commodityListData: null,
  commodityListError: null,

  currencyListLoading: null,
  currencyListData: null,
  currencyListError: null,
};

const stockDiscovery = (state = INITIAL_STATE, { type, payload, meta }) => {
  switch (type) {
    case ON_ADD_WATCHLIST_SUCCESS:
      if (state.stockDiscoveryData) {
        Object.keys(state.stockDiscoveryData).forEach((groupCode) => {
          const stockGroup = state.stockDiscoveryData[groupCode];
          if (stockGroup) {
            stockGroup.results = stockGroup.results.map((r) => {
                if (r.code === payload.code) {
                  r.watchlisted = true;
                }
                return { ...r };
              });
          }
        });
      }
      return {
        ...state,
        stockDiscoveryData: {
          ...state.stockDiscoveryData,
        },
      };
    case ON_REMOVE_WATCHLIST_SUCCESS:
      if (state.stockDiscoveryData) {
        Object.keys(state.stockDiscoveryData).forEach((groupCode) => {
          const stockGroup = state.stockDiscoveryData[groupCode];
          if (stockGroup) {
            stockGroup.results = stockGroup.results.map((r) => {
                if (r.code === meta.code) {
                  r.watchlisted = false;
                }
                return { ...r };
              });
          }
        });
      }
      return {
        ...state,
        stockDiscoveryData: {
          ...state.stockDiscoveryData,
        },
      };
    case ON_REQUEST_STOCK_DISCOVERY:
      return {
        ...state,
        stockDiscoveryLoading: {
          ...state.stockDiscoveryLoading,
          [meta.groupCode]: true,
        },
      };
    case ON_REQUEST_STOCK_DISCOVERY_SUCCESS:
      if (
        meta.resetState
        && state.stockDiscoveryData
        && state.stockDiscoveryData[meta.groupCode]
      ) {
        delete state.stockDiscoveryData[meta.groupCode];
      }
      if (
        state.stockDiscoveryData
        && state.stockDiscoveryData[meta.groupCode]
      ) {
        state.stockDiscoveryData[meta.groupCode] = {
          ...payload,
          results: [
            ...state.stockDiscoveryData[meta.groupCode].results,
            ...payload.results,
          ],
        };
      } else {
        state.stockDiscoveryData = {
          ...state.stockDiscoveryData,
          [meta.groupCode]: payload,
        };
      }
      return {
        ...state,
        stockDiscoveryLoading: {
          ...state.stockDiscoveryLoading,
          [meta.groupCode]: false,
        },
        stockDiscoveryError: {
          ...state.stockDiscoveryError,
          [meta.groupCode]: null,
        },
      };
    case ON_REQUEST_STOCK_DISCOVERY_FAILURE:
      return {
        ...state,
        stockDiscoveryLoading: {
          ...state.stockDiscoveryLoading,
          [meta.groupCode]: false,
        },
        stockDiscoveryError: {
          ...state.stockDiscoveryError,
          [meta.groupCode]: payload,
        },
      };

    case ON_PRICE_SOCKET_CHANGE:
      if (state.stockDiscoveryData) {
        const datum = payload;
        if (!datum.ticker) return state;
        let hasDataChange = false;
        for (const groupCode in state.stockDiscoveryData) {
          const stockGroup = state.stockDiscoveryData[groupCode];
          if (stockGroup.results) {
            const idxResult = state.stockDiscoveryData[
              groupCode
            ].results.findIndex(r => r.code === datum.ticker);
            if (idxResult === -1) continue;
            hasDataChange = true;
            stockGroup.results[idxResult].change = datum.change;
            stockGroup.results[idxResult].change_pct = datum.pctChange;
            stockGroup.results[idxResult].old_price = stockGroup.results[idxResult].price;
            stockGroup.results[idxResult].price = datum.price;
            if (
              typeof datum.tradableVolume !== 'undefined'
              && datum.tradableVolume !== null
            ) {
              state.stockDiscoveryData[groupCode].results[
                idxResult
              ].tradable_volume = datum.tradableVolume;
            }
          }
        }
        if (hasDataChange) {
          return {
            ...state,
            stockDiscoveryData: {
              ...state.stockDiscoveryData,
            },
          };
        }
      }
      return state;

    case ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY:
      if (state.stockGraphDiscoveryLoading[meta.vendorCode]) {
        state.stockGraphDiscoveryLoading[meta.vendorCode] = {
          ...state.stockGraphDiscoveryLoading[meta.vendorCode],
          [meta.rangeCode]: true,
        };
      } else {
        state.stockGraphDiscoveryLoading[meta.vendorCode] = {
          [meta.rangeCode]: true,
        };
      }
      return {
        ...state,
      };
    case ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_SUCCESS:
      if (state.stockGraphDiscoveryLoading[meta.vendorCode]) {
        state.stockGraphDiscoveryLoading[meta.vendorCode] = {
          ...state.stockGraphDiscoveryLoading[meta.vendorCode],
          [meta.rangeCode]: false,
        };
      } else {
        state.stockGraphDiscoveryLoading[meta.vendorCode] = {
          [meta.rangeCode]: false,
        };
      }
      if (state.stockGraphDiscoveryData[meta.vendorCode]) {
        state.stockGraphDiscoveryData[meta.vendorCode] = {
          ...state.stockGraphDiscoveryData[meta.vendorCode],
          [meta.rangeCode]: payload,
        };
      } else {
        state.stockGraphDiscoveryData[meta.vendorCode] = {
          [meta.rangeCode]: payload,
        };
      }
      if (state.stockGraphDiscoveryError[meta.vendorCode]) {
        state.stockGraphDiscoveryError[meta.vendorCode] = {
          ...state.stockGraphDiscoveryError[meta.vendorCode],
          [meta.rangeCode]: null,
        };
      } else {
        state.stockGraphDiscoveryError[meta.vendorCode] = {
          [meta.rangeCode]: null,
        };
      }
      return {
        ...state,
      };
    case ON_REQUEST_MARKET_INDEX_GRAPH_DISCOVERY_FAILURE:
      if (state.stockGraphDiscoveryLoading[meta.vendorCode]) {
        state.stockGraphDiscoveryLoading[meta.vendorCode] = {
          ...state.stockGraphDiscoveryLoading[meta.vendorCode],
          [meta.rangeCode]: false,
        };
      } else {
        state.stockGraphDiscoveryLoading[meta.vendorCode] = {
          [meta.rangeCode]: false,
        };
      }
      if (state.stockGraphDiscoveryData[meta.vendorCode]) {
        state.stockGraphDiscoveryData[meta.vendorCode] = {
          ...state.stockGraphDiscoveryData[meta.vendorCode],
          [meta.rangeCode]: null,
        };
      } else {
        state.stockGraphDiscoveryData[meta.vendorCode] = {
          [meta.rangeCode]: null,
        };
      }
      if (state.stockGraphDiscoveryError[meta.vendorCode]) {
        state.stockGraphDiscoveryError[meta.vendorCode] = {
          ...state.stockGraphDiscoveryError[meta.vendorCode],
          [meta.rangeCode]: payload,
        };
      } else {
        state.stockGraphDiscoveryError[meta.vendorCode] = {
          [meta.rangeCode]: payload,
        };
      }
      return {
        ...state,
      };

    // candlestick

    case ON_REQUEST_CANDLESTICK_GRAPH:
      return {
        ...state,
        candleStickLoading: true,
        candleStickData: null,
        candleStickError: null,
      };
    case ON_REQUEST_CANDLESTICK_GRAPH_SUCCESS:
      return {
        ...state,
        candleStickLoading: false,
        candleStickData: payload.result,
        candleStickError: null,
      };
    case ON_REQUEST_CANDLESTICK_GRAPH_FAILURE:
      return {
        ...state,
        candleStickLoading: false,
        candleStickError: payload,
      };

    case ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY:
      if (meta.resetData) {
        return {
          ...state,
          marketIndexListLoading: true,
          marketIndexListData: null,
          marketIndexListError: null,
        };
      }
      return {
        ...state,
        marketIndexListLoading: true,
        marketIndexListError: null,
      };
    case ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_SUCCESS:
      if (state.marketIndexListData) {
        const oldResults = [...state.marketIndexListData.results];
        state.marketIndexListData = {
          ...payload,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.marketIndexListData = payload;
      }

      return {
        ...state,
        marketIndexListLoading: false,
        marketIndexListError: null,
      };
    case ON_REQUEST_MARKET_INDEX_LIST_DISCOVERY_FAILURE:
      return {
        ...state,
        marketIndexListLoading: false,
        marketIndexListError: payload,
      };

    case ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE:
      if (meta.resetState) {
        return {
          ...state,
          stockDiscoveryTypeLoading: {
            ...state.stockDiscoveryTypeLoading,
            [meta.type]: true,
          },
          stockDiscoveryTypeData: {
            ...state.stockDiscoveryTypeData,
            [meta.type]: null,
          },
        };
      }
      return {
        ...state,
        stockDiscoveryTypeLoading: {
          ...state.stockDiscoveryTypeLoading,
          [meta.type]: true,
        },
      };
    case ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_SUCCESS:
      if (state.stockDiscoveryTypeData[meta.type]) {
        if (payload.results.length > 0) {
          state.stockDiscoveryTypeData[meta.type] = {
            ...payload,
            results: [
              ...state.stockDiscoveryTypeData[meta.type].results,
              ...payload.results,
            ],
          };
        }
      } else {
        state.stockDiscoveryTypeData = {
          ...state.stockDiscoveryTypeData,
          [meta.type]: payload,
        };
      }

      return {
        ...state,
        stockDiscoveryTypeLoading: {
          ...state.stockDiscoveryTypeLoading,
          [meta.type]: false,
        },
        stockDiscoveryTypeError: {
          ...state.stockDiscoveryTypeError,
          [meta.type]: payload,
        },
      };
    case ON_REQUEST_STOCK_DISCOVERY_GROUP_TYPE_FAILURE:
      return {
        ...state,
        stockDiscoveryTypeLoading: {
          ...state.stockDiscoveryTypeLoading,
          [meta.type]: false,
        },
        stockDiscoveryTypeError: {
          ...state.stockDiscoveryTypeError,
          [meta.type]: payload,
        },
      };
    case ON_DO_SET_FILTER: {
      return {
        ...state,
        selectedFilter: payload,
      };
    }
    case ON_REQUEST_ETF_LIST:
      if (meta.resetData) {
        return {
          ...state,
          etfListLoading: true,
          etfListData: null,
          etfListError: null,
        };
      }
      return {
        ...state,
        etfListLoading: true,
        etfListError: null,
      };

    case ON_REQUEST_ETF_LIST_SUCCESS:
      if (state.etfListData) {
        const oldResults = [...state.etfListData.results];

        state.etfListData = {
          ...payload,
          count: payload.count,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.etfListData = payload;
      }
      return {
        ...state,
        etfListLoading: false,
        etfListError: null,
      };
    case ON_REQUEST_ETF_LIST_FAILURE:
      return {
        ...state,
        etfListLoading: false,
        etfListError: payload,
      };

    case ON_REQUEST_COMMODITY_LIST:
      if (meta.resetData) {
        return {
          ...state,
          commodityListLoading: true,
          commodityListData: null,
          commodityListError: null,
        };
      }
      return {
        ...state,
        commodityListLoading: true,
        commodityListError: null,
      };

    case ON_REQUEST_COMMODITY_LIST_SUCCESS:
      if (state.etfListData) {
        const oldResults = [...state.commodityListData.results];

        state.commodityListData = {
          count: payload.count,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.commodityListData = payload;
      }
      return {
        ...state,
        commodityListLoading: false,
        commodityListError: null,
      };
    case ON_REQUEST_COMMODITY_LIST_FAILURE:
      return {
        ...state,
        commodityListLoading: false,
        commodityListError: payload,
      };

    case ON_REQUEST_CURRENCY_LIST:
      if (meta.resetData) {
        return {
          ...state,
          currencyListLoading: true,
          currencyListData: null,
          currencyListError: null,
        };
      }
      return {
        ...state,
        currencyListLoading: true,
        currencyListError: null,
      };

    case ON_REQUEST_CURRENCY_LIST_SUCCESS:
      if (state.etfListData) {
        const oldResults = [...state.currencyListData.result];

        state.currencyListData = {
          count: payload.count,
          result: [...oldResults, ...payload.result],
        };
      } else {
        state.currencyListData = payload;
      }
      return {
        ...state,
        currencyListLoading: false,
        currencyListError: null,
      };
    case ON_REQUEST_CURRENCY_LIST_FAILURE:
      return {
        ...state,
        currencyListLoading: false,
        currencyListError: payload,
      };

    default:
      return state;
  }
};

export default stockDiscovery;
